import { render, staticRenderFns } from "./applyRequest.vue?vue&type=template&id=3064b962&scoped=true&"
import script from "./applyRequest.vue?vue&type=script&lang=js&"
export * from "./applyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064b962",
  null
  
)

export default component.exports